<template>
  <div>
    <v-alert type="error" v-if="errorResponse != null" outlined dismissible>
    <h3>Login error</h3>
    <strong v-html="errorResponse.status"></strong>
    {{ errorResponse.data.detail }}        
  </v-alert>
  </div>
</template>
<script>
import { createSession } from '../utils/auth.js'


export default {
  name: 'Home',

  data() {
    return {
      errorResponse: null,
    };
  },
  mounted() {
    createSession(this.$store, this.$route).then(response => {
      this.$store.dispatch('setUserFromServer').then(newpromise => {
        console.log("Checking if user was set by server", this.$store.state.user, newpromise)
        if ( ! this.$store.state.user ) {
            this.errorResponse = {
                status: "000",
                data: {
                    detail: "User could not be verified."
                }
            }
        }
      })
      this.$router.push('/')
    }).catch((error) => {
      this.errorResponse = error.response;
    });

  },
};
</script>